export default {
  pageTitle: 'Manage My Stores',
  applyStore: 'Apply for a new store',
  payMethod: '保证金缴纳方式',
  bank: 'bank',
  bankAccount: 'bankAccount',
  payee: 'payee',
  paymentTerm: 'payment term',
  marginStatusList1: 'Pending',
  marginStatusList2: '已缴纳',
  statusType1: 'Open',
  statusType2: '打烊',
  statusType3: '关店',
  storeType1: '个人',
  storeType2: 'Enterprise',
  columns1: 'Store Type',
  columns2: 'Store Level',
  columns3: 'Store Name',
  columns4: 'Store Logo',
  storeInfo: 'Store Info',
  columns5: 'Create Time',
  columns6: 'CommissionRate',
  columns8: 'Security deposit Status',
  columns9: '查看',
  storeId: 'Store ID',
  approvedStores: 'Approved Stores',
  pendingReviewStores: 'Pending Review Stores',
  rejectedStores: 'Rejected Stores',
  operation: 'Operation',
  edit: 'Edit',
  latestRejectionReason: 'Latest Rejection Reason',
  applicationTime: 'Application Time',
  view: 'View',
  basicMarketplace: 'Basic Marketplace',
  createDate: 'Create Date',
  open: 'Open',
  temporarilyClosed: 'Temporarily Closed',
  locked: 'Locked',
  permanentlyClosed: 'Permanently Closed',
  viewCommissionRates: 'Commission Rates',
  viewKilimallSellerEContract: 'Kilimall Seller e-Contract',
  viewLipaPayTermConditions: 'LipaPay Terms&Conditions',
  viewQualification: 'View Qualification',
  storeQualification: 'Store Qualification',
  revisionApplicationRecord: 'Revision Application Record',
  applicationId: 'Application ID',
  scope: 'Scope',
  type: 'Type',
  applyDate: 'Apply Date',
  auditDate: 'Audit Date',
  cancel: 'Cancel',
  details: 'Details',
  inReview: 'In Review',
  approved: 'Approved',
  rejected: 'Rejected',
  canceled: 'Canceled',
  pleaseSelectReviseType: 'Please select revise type',
  areYouSureCancelApplication: 'Are you sure to cancel this revision application?',
  yesCancelIt: 'Yes, cancel it',
  noKeepIt: 'No, keep it',
  basicInformation: 'Basic Information',
  basicOwnerInformation: 'Business Owner or Legal Representative Information',
  settlementInfo: 'Settlement Information',
  submitRevisionApplication: 'Submit revision application',
  submitRevisionApplicationTip: 'Due to the adjustment of the platform policy, modifying store business information or settlement information will be applied to all stores under the merchant. Submitting indicates that you are aware of and agree to this policy',
  revise: 'Revise',
  cancelRevision: 'Cancel revision',
  changeToANewOne: 'Change to a new one',
  correctTheWrongInfo: 'Correct the wrong information',
  doYouAgreeQualifications: 'Do you agree to apply the same correction to the qualifications of the following stores under your account?',
  noDisagree: 'No, disagree',
  yesAgree: 'Yes, agree',
  status: 'Status',
  storeStatus: 'Status',
  theOriginalCannotIndividually: 'The original qualifications cover multiple stores and cannot be corrected individually.',
  indicatesStatusBasic: 'Indicates the store status on basic marketplace.',
  failedBecauseHaveNotRevised: 'Failed, because you have not revised any information.',
  failedBecauseLockedOrClosed: 'Failed, because this store is locked or permanently closed.',
  correction: 'Correction',
  change: 'Change',
  qualifications: 'Qualifications',
  settlement: 'Settlement',
  representative: 'Representative',
  missingInfoSupplement: 'Missing information supplement',
  supplement: 'Supplement',
  closeStore: 'Close Store',
  applyCloseRegion: 'Apply to close the Country Site',
  confirm: 'Confirm',
  requestingCloseBaseStation: 'The basic marketplace you applied to close, please select a new one',
  previous: 'Previous',
  baseStation: 'Base',
  pleaseSelect: 'please select',
  closureApplicationStores: 'Closure Application Stores',
  applicationDate: 'Application Date',
  storeRegion: 'Store Region',
  feedbackDate: 'Feedback Date',
  refundSuccess: 'Refund'
}
